import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import $ from 'jquery';
import { ImpactAnalysisDiffData } from '@app/shared/components/dialogs/impact-analysis-diff-dialog/impact-analysis-diff-dialog.data';
import 'codemirror/theme/base16-light.css';
import 'codemirror/mode/sql/sql';
import CodeMirror from 'codemirror';
import 'codemirror/addon/merge/merge';

@Component({
    selector : 'impact-analysis-diff-dialog"',
    template: require('./impact-analysis-diff-dialog.component.html'),
    styles: [require('./impact-analysis-diff-dialog.component.scss')]
})
export class ImpactAnalysisDiffDialogComponent {
     activityName : string;
     textName : string;
     activityResult : any;
     surceCode:string
     unSubscribe :any
     isbuild : boolean
     targetCode:string
     baselineCode:string
     envName:string
       dv : any
     public textActivity: string
    constructor(@Inject(MAT_DIALOG_DATA) public data: ImpactAnalysisDiffData ) {
        this.isbuild = data.isBuild
        this.surceCode = data.sourceCode
        this.baselineCode = data.baselineCode
        this.targetCode = data.targetCode
        this.envName = data.envName
    }

    public async ngAfterViewInit() {
        $("#codediff").empty();
        this.dv = CodeMirror.MergeView($("#codediff")[0], {
            value: this.surceCode ,
            origLeft: this.baselineCode ? this.baselineCode : null,
            orig: this.targetCode ? this.targetCode : "",
            lineWarp: true,
            indentWithTabs: true,
            smartIndent: true,
            readOnly: true,
            lineNumbers: false,
            matchBrackets : true,
            highlightDifferences: true,
            mode: 'text/x-sql',
            // theme: 'material',
            revertButtons: false,
            connect: true,
            // collapseIdentical: collapse
        });
       setTimeout(() => {
            this.resize(this.dv);
            $(".CodeMirror").height(370);
            if (!this.isbuild) {    
                $(".CodeMirror-merge-editor").append("<div class='sourceTitle'>Actual</div>");
                $(".CodeMirror-merge-pane-rightmost").append("<div class='targetTitle'>Expected</div>");
            }
            else {
                $(".CodeMirror-merge-editor").append(`<div class='sourceTitle'>${this.envName}</div>`);
                $(".CodeMirror-merge-pane-rightmost").append("<div class='targetTitle'>Release Source</div>");
            }
        }, 50);
    }

      mergeViewHeight(mergeView) {
        return Math.max(this.editorHeight(mergeView.leftOriginal()),
                        this.editorHeight(mergeView.editor()),
                        this.editorHeight(mergeView.rightOriginal()));
      }

      editorHeight(editor) {
        if (!editor) return 0;
        return editor.getScrollInfo().height;
      }
      
      resize(mergeView) {
        // mergeView.editor().setOption('mode', 'text/x-sql');
        // mergeView.editor().refresh();
        // mergeView.rightOriginal().setOption('mode', 'text/x-sql');
        // mergeView.rightOriginal().forceUpdate("full");
        let height = this.mergeViewHeight(mergeView);
        height = 370;
        for(;;) {
          if (mergeView.leftOriginal())
            mergeView.leftOriginal().setSize(null, height);
          mergeView.editor().setSize(null, height);
          if (mergeView.rightOriginal())
            mergeView.rightOriginal().setSize(null, height);
      
          var newHeight = this.mergeViewHeight(mergeView);
          if (newHeight >= height) break;
          else height = newHeight;
        }
        mergeView.wrap.style.height = 370 + "px";
      }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/impact-analysis-diff-dialog/impact-analysis-diff-dialog.component.ts